module.exports = __webpack_public_path__ + "img/placeholder_img.89968bd7.svg";